export class Filter {
  category: string = 'licences';
  regions: string[]=[];
  country: string = '';
  bandGroup: string = '';
  band: string = '';
  constructor() {}
}
